import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { MatSnackBar } from "@angular/material";
import { MatAccordion } from "@angular/material/expansion";
import { retry } from "rxjs/operators";
import { Practitioner } from "src/app/core/model/v2/practitioner/practitioner";
import { PracticeService } from "src/app/core/services/v2/practice.service";
import { UserService } from "src/app/core/services/v2/user.service";
import { WindowLoaderService } from "../../window-loader/window-loader.service";

@Component({
  selector: "app-timing-card-dialog",
  templateUrl: "./timing-card-dialog.component.html",
  styleUrls: ["./timing-card-dialog.component.scss"],
})
export class TimingCardDialogComponent implements OnInit {
  @ViewChild(MatAccordion, { static: false }) accordion: MatAccordion;
  @Input() practitionerData: Practitioner = new Practitioner();
  @Output() toggleSidebar = new EventEmitter();
  editTimingsForm: FormGroup;
  workingDaysHours: any;
  currentUserId: number;
  loggedPractitionerId: number;
  workingHoursJson = [
    {
      day: "Monday",
      hours: [],
    },
    {
      day: "Tuesday",
      hours: [],
    },
    {
      day: "Wednesday",
      hours: [],
    },
    {
      day: "Thursday",
      hours: [],
    },
    {
      day: "Friday",
      hours: [],
    },
    {
      day: "Saturday",
      hours: [],
    },
    {
      day: "Sunday",
      hours: [],
    },
  ];

  constructor(
    private fb: FormBuilder,
    private _practiceService: PracticeService,
    private _userService: UserService,
    private _loaderService: WindowLoaderService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.inizializeTimings();
    this.getUserDetails();
  }

  getUserDetails() {
    this._userService.getUserDetails().subscribe(
      (userDetails) => {
        this.loggedPractitionerId = userDetails.practitionerId;
        this.currentUserId = userDetails.id; //['id'];
      },
      (error) => {
        console.error(error);
      },
      () => {
        this._loaderService.hide();
      }
    );
  }

  get healthSystem() {
    return this.editTimingsForm.get("healthSystem") as FormArray;
  }

  get workingHours() {
    return this.healthSystem.get("workingHours") as FormArray;
  }

  get hours(): FormArray {
    return this.workingHours.get("hours") as FormArray;
  }

  inizializeTimings() {
    this.workingDaysHours = [...this.workingHoursJson];
    this.practitionerData.healthSystems.map;
    this.editTimingsForm = this.fb.group({
      healthSystem: this.fb.array(
        this.practitionerData.healthSystems
          ? this.practitionerData.healthSystems.map((hs) => {
              return this.fb.group({
                name: hs.name,
                id: hs.id,
                workingHours: this.fb.array(
                  hs.workingHours
                    ? hs.workingHours.map((wh) => {
                        return this.fb.group({
                          day: wh.day,
                          hours: this.fb.array(
                            wh.hours
                              ? wh.hours.map((hr) => {
                                  return this.fb.group({
                                    timeFrom: [
                                      hr && hr != "Closed"
                                        ? hr.split("-")[0].trim()
                                        : "",
                                    ],
                                    timeTo: [
                                      hr && hr != "Closed"
                                        ? hr.split("-")[1].trim()
                                        : "",
                                    ],
                                  });
                                })
                              : []
                          ),
                        });
                      })
                    : []
                ),
              });
            })
          : []
      ),
    });
  }

  validation(i, j, k) {
    console.log(
      this.healthSystem.controls[i]
        .get("workingHours")
        ["controls"][j].get("hours")
        ["controls"][k].get("timeFrom")
    );
    this.healthSystem.controls[i]
      .get("workingHours")
      ["controls"][j].get("hours")
      ["controls"][k].get("timeFrom") >
      this.healthSystem.controls[i]
        .get("workingHours")
        ["controls"][j].get("hours")
        ["controls"][k].get("timeFrom");
  }

  restHours(i, j) {
    this.healthSystem.controls[i]
      .get("workingHours")
      ["controls"][j].get("hours")
      .reset();
  }

  addHours(i, j): void {
    this.healthSystem.controls[i]
      .get("workingHours")
      ["controls"][j].get("hours")
      ["controls"].push(
        this.fb.group({
          timeFrom: new FormControl(""),
          timeTo: new FormControl(""),
        })
      );
  }

  updateTimings(i) {
    let workingData = this.editTimingsForm.value.healthSystem[
      i
    ].workingHours.map((wh) => {
      return {
        day: wh.day,
        hours:
          wh.hours[0].timeFrom === null || wh.hours[0].timeTo === null
            ? ["Closed"]
            : wh.hours
                .filter((hr, i) => {
                  if (hr.timeFrom != null || hr.timeTo != null) {
                    return true;
                  }
                })
                .map((hd) => {
                  return hd.timeFrom + "-" + hd.timeTo;
                }),
      };
    });
    const physicianWH = {
      practitionerId: this.practitionerData.id,
      userId:
        this.loggedPractitionerId == this.practitionerData.id
          ? this.currentUserId
          : 0,
      healthSystemId: this.editTimingsForm.value.healthSystem[i].id,
      workingHours: workingData,
    };
    this._practiceService
      .updatePractitionerWorkingHours(physicianWH)
      .subscribe((res) => {
        if (res.resultStatus.isSuccess) {
          if (res.result) {
            this._snackBar.open("Timings Updated", "", {
              duration: 5000,
            });
          }
        } else {
          console.error(res);
        }
      });
  }

  cancel() {
    this.toggleSidebar.emit();
  }
}
